import TrainingInspector from './TrainingInspector'

export { TrainingInspector }
export default TrainingInspector
